import { getLanguageFromStorage } from 'syf-js-utilities';
import { StorageType } from '../const/alertsConfig';
var SyfStorage = {
    setAccessToken: function (token) {
        sessionStorage.setItem(StorageType.ACCESS_TOKEN, token);
    },
    getAccessToken: function () {
        return sessionStorage.getItem(StorageType.ACCESS_TOKEN);
    },
    removeAccessToken: function () {
        sessionStorage.removeItem(StorageType.ACCESS_TOKEN);
    },
    setCorrelationId: function (correlationId) {
        sessionStorage.setItem(StorageType.CORRELATION_ID, correlationId);
    },
    getCorrelationId: function () {
        return sessionStorage.getItem(StorageType.CORRELATION_ID);
    },
    removeCorrelationId: function () {
        sessionStorage.removeItem(StorageType.CORRELATION_ID);
    },
    setLanguage: function (lang) {
        localStorage.setItem(StorageType.LANGUAGE, lang || 'es');
    },
    getLanguage: function () {
        return getLanguageFromStorage();
    },
    setEnvironment: function (environment) {
        sessionStorage.setItem(StorageType.SELECTED_ENV, environment);
    },
    getEnvironment: function () {
        return sessionStorage.getItem(StorageType.SELECTED_ENV);
    },
    setClientType: function (clientType) {
        sessionStorage.setItem(StorageType.SELECTED_CLIENT_TYPE, clientType);
    },
    getClientType: function () {
        return sessionStorage.getItem(StorageType.SELECTED_CLIENT_TYPE);
    }
};
export default SyfStorage;
